<!-- <router-outlet></router-outlet>
<app-user-table [title]="title"></app-user-table> -->

<div class="page-wrap" #mainLayout>
  <mat-progress-bar [mode]="mode" [color]="color" style="padding:3.5px 0;" *ngIf="loader" class="loader"></mat-progress-bar>
  <div class="outlet_wrapper"><router-outlet></router-outlet></div>
  </div>